import React from 'react';
import { Table, Button, Typography, Card } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const { Title } = Typography;

const recursos = [
  {
    key: '1',
    nombre: 'Formato de informe mensual',
    tipo: 'Documento',
    descripcion: 'Plantilla para informes de actividades mensuales',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
  {
    key: '2',
    nombre: 'Manual del docente',
    tipo: 'PDF',
    descripcion: 'Guía de buenas prácticas para docentes',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
  {
    key: '3',
    nombre: 'Logo institucional (png)',
    tipo: 'Imagen',
    descripcion: 'Versión transparente del logo institucional',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
  {
    key: '4',
    nombre: 'Formato de planificación',
    tipo: 'Excel',
    descripcion: 'Archivo para planificaciones académicas',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
  {
    key: '5',
    nombre: 'Calendario académico',
    tipo: 'PDF',
    descripcion: 'Cronograma del ciclo lectivo actual',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
  {
    key: '6',
    nombre: 'Instructivo de uso del aula virtual',
    tipo: 'PDF',
    descripcion: 'Guía paso a paso para el aula virtual',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
  {
    key: '7',
    nombre: 'Formato de asistencia',
    tipo: 'Documento',
    descripcion: 'Plantilla para control de asistencia',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
  {
    key: '8',
    nombre: 'Reglamento institucional',
    tipo: 'PDF',
    descripcion: 'Reglamento completo actualizado',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
  {
    key: '9',
    nombre: 'Presentación institucional',
    tipo: 'PowerPoint',
    descripcion: 'PPT con información institucional general',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
  {
    key: '10',
    nombre: 'Formato para evaluaciones',
    tipo: 'Word',
    descripcion: 'Plantilla para exámenes escritos',
    enlace: 'https://www.facebook.com/ProvinciaDeLosRios',
  },
];

const columnas = [
  {
    title: 'Nombre',
    dataIndex: 'nombre',
    key: 'nombre',
  },
  {
    title: 'Tipo',
    dataIndex: 'tipo',
    key: 'tipo',
  },
  {
    title: 'Descripción',
    dataIndex: 'descripcion',
    key: 'descripcion',
  },
  {
    title: 'Descargar',
    key: 'accion',
    render: (_, record) => (
      <Button
        type="link"
        icon={<DownloadOutlined />}
        href={record.enlace}
        target="_blank"
        disabled={record.enlace === '#'}
      >
        Descargar
      </Button>
    ),
  },
];

const RecursosGenerales = () => {
  return (
    <Card style={{ maxWidth: 1000, margin: 'auto' }}>
      <Title level={4}>Recursos Generales para Docentes</Title>
      <Table
        dataSource={recursos}
        columns={columnas}
        pagination={{ pageSize: 5 }}
        bordered
      />
    </Card>
  );
};

export default RecursosGenerales;
